
/**
 * @param {TrackingAnalytics} analytics
 */
function CatalogPromotionTracker(analytics) {
    'use strict';

    this.analytics = analytics;
    this.$promotions = $('.catalog__promotion');
}

CatalogPromotionTracker.prototype = {

    init: function () {
        'use strict';

        if (!this.$promotions.length) {
            return;
        }

        this.$promotions.each(this.initPromotionTracking.bind(this));
    },

    /**
     *
     * @param {Number} index
     * @param {Node} element
     * @returns {CatalogPromotionTracker}
     */
    initPromotionTracking: function (index, element) {
        'use strict';

        var $promotion = $(element);

        $promotion.on('click', this.trackPromotion.bind(this, $promotion));

        return this;
    },

    /**
     * @param {Object} $promotion
     */
    trackPromotion: function ($promotion) {
        'use strict';

        var promoId = $promotion.data('id');
        this.analytics.setEcommerceAction('promo_click', window.GADATA.promotions[promoId]);
        this.analytics.track('Catalog', 'Promo Click', promoId, 1);
    }
};

export default CatalogPromotionTracker;